import { gql } from 'apollo-boost';
import { BaseApi } from '@smorder/logic';

class MenuApi extends BaseApi {
  * loadMenuTree(locationId) {
    return yield this.authorizedGraphQLFetch(gql`
    {
      menus(locationid: ${locationId}) {
        id
        name
        orderable
        icon
        visibleInApp
        categories {
          id
          imageUrl
          categoryIcon
          name
          orderable
          visible
          menuEntries {
            id
            name
            orderable
            visible
            productId
          }
        }
      }
    }`, '/graphql');
  }

  * updateMenu({ menuId, data }) {
    return yield this.authorizedFetch(`/api/v1/waiter/menus/${menuId}`, {
      method: 'PUT',
      body: JSON.stringify(data),
    });
  }

  * updateCategory({ categoryId, data }) {
    return yield this.authorizedFetch(`/api/v1/waiter/categories/${categoryId}`, {
      method: 'PUT',
      body: JSON.stringify(data),
    });
  }

  * updateMenuEntry({ menuEntryId, data }) {
    return yield this.authorizedFetch(`/api/v1/waiter/menuEntries/${menuEntryId}`, {
      method: 'PUT',
      body: JSON.stringify(data),
    });
  }

  * loadProducts(locationId) {
    return yield this.authorizedFetch(`/api/v1/customer/locations/${locationId}/Products`);
  }

  * updateProduct({ productId, data }) {
    return yield this.authorizedFetch(`/api/v1/waiter/products/${productId}`, {
      method: 'PUT',
      body: JSON.stringify(data),
    });
  }

  * loadProductionPlaces(locationId) {
    return yield this.authorizedFetch(`/api/v1/locations/${locationId}/productionPlaces`);
  }
}

export default MenuApi;
